import { DialogComponent } from '@theme/dialog';

/**
 * Right-side product details drawer – MORE DETAILS on product pages.
 * Slides in from the right with YSL-style opacity animation.
 * Closes on overlay click, ESC, or X button.
 *
 * @extends {DialogComponent}
 */
class ProductDetailsDrawerComponent extends DialogComponent {
  requiredRefs = ['dialog'];
}

if (!customElements.get('product-details-drawer-component')) {
  customElements.define('product-details-drawer-component', ProductDetailsDrawerComponent);
}

export { ProductDetailsDrawerComponent };
